import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%2C%20beautiful%20abstract%20composition%20with%20warm%20amber%20and%20soft%20coral%20gradients%2C%20stylized%20Korean%20comic%20panel%20aesthetic%2C%20dynamic%20flowing%20lines%2C%20dreamy%20atmosphere%2C%20delicate%20watercolor%20texture%2C%20clean%20minimal%20background%20with%20artistic%20brush%20strokes%2C%20soft%20glowing%20light%20effects%2C%20elegant%20visual%20storytelling%20mood&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="韩漫屋 - 好看的韩国漫画免费阅读平台"
        title="韩漫屋 - 好看的韩国漫画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          好看的韩国漫画
          <span className="block text-primary-400 mt-2">尽在韩漫屋</span>
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫免费阅读平台，汇集海量热门韩国漫画。每日更新，高清画质，流畅阅读体验。
          通过韩漫网址快速访问韩漫屋，开启您的漫画之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3.5 bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            热门恋爱
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10,000+</p>
            <p className="text-xs text-background-300 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</p>
            <p className="text-xs text-background-300 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">每日更新</p>
            <p className="text-xs text-background-300 mt-1">稳定连载</p>
          </div>
        </div>
      </div>
    </section>
  );
}